export default __webpack_public_path__ + "static/media/kingdom-points-tutorial@3x.82093010.png";